import React, { Fragment, useEffect, useMemo, useState, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { BreadcrumbComponent, BreadcrumbItemDirective, BreadcrumbItemsDirective } from '@syncfusion/ej2-react-navigations';

import { LibrarySourceType, LibraryTraceCrumb } from './types/ThirdPartyLibrary'
import { clearNavTiles, clearRootCategoryId, fetchSubTiles, removeFromNavTrace, setSelectedSource, setSuccess, setUpThirdPartyLibraries } from './redux/actions'

import './NavTrace.scss'

interface NavTrace {
    rootCategory?:{
        id: number|string,
        isPatternContainer:boolean,
        categoryName:string,
        isOpenToUse:boolean,
    }|null,
    source: LibrarySourceType
    thirdPartyImageSource: string[]
    trace: LibraryTraceCrumb[]
}

const backgroundColors = ['#494848', '#909090', '#b4b4b4', '#494848', '#909090', '#b4b4b4']

// export const NavTrace = (props: NavTrace) => {
//     const { width, rootCategory, source, thirdPartyImageSource, trace } = props

//     const { id, isOpenToUse, categoryName = "Selected category" } = rootCategory || {}

//     const dispatch = useDispatch();

//     const [rootId, setRootId] = useState(id as any);

//     useEffect(() => {
//         setRootId(id)
//     }, [id])

//     const navTrace = useMemo(() => {
//         return trace.map((crumb, index) => <Fragment>
//             <div onClick={() => {
//                 if (index < trace.length - 1) {
//                     dispatch(removeFromNavTrace(crumb))
//                     dispatch(fetchSubTiles(source as LibrarySourceType, crumb, 0))
//                 }
//             }} className='library_navtrace_crumb'
//                 style={{ backgroundColor: backgroundColors[index + 1] }}
//                 data-id={crumb.id}>{crumb.name}</div>
//         </Fragment>
//         )
//     }, [trace, source])

//     const isRootIdAvailable = rootId && (rootId !== 'evroot') && isOpenToUse
//     const primaryNavlabel = (source === 'patternDesigns' ? 'All Categories' : 'Search Results')

//     return <div className='library_navtrace' style={{ width: width || 'auto' }}>
//         {(width && width > 200) ? <div style={{ height: '100%', width, display: 'flex', alignItems: 'center', overflow: 'hidden', minWidth: 500 }}>
//             {isRootIdAvailable ? <div onClick={() => {
//                 if (source === 'patternDesigns') {
//                     dispatch(clearRootCategoryId())
//                     dispatch(clearNavTiles())
//                     dispatch(setSelectedSource(source))
//                     dispatch(setUpThirdPartyLibraries(thirdPartyImageSource))
//                 }
//             }}
//                 className='library_navtrace_all-categories'>{primaryNavlabel}</div> :
//                 <div onClick={() => {
//                     if (source === 'patternDesigns') {
//                         dispatch(setSuccess(source))
//                         dispatch(clearNavTiles())
//                         dispatch(setSelectedSource(source))
//                     }
//                 }} className='library_navtrace_source'
//                     style={{ backgroundColor: backgroundColors[0] }}
//                 >{primaryNavlabel}</div>}
//             {navTrace}
//         </div> : null}
//     </div>
// }

// export const NavLabel = (props: any) => {
//     const { crumb, index, source, trace } = props
//     const dispatch = useDispatch();

//     return <div onClick={() => {
//         if (index < trace.length - 1) {
//             dispatch(removeFromNavTrace(crumb))
//             dispatch(fetchSubTiles(source as LibrarySourceType, crumb, 0))
//         }
//     }} className='library_navtrace_crumb' data-id={crumb.id}>{crumb.name}</div>
// }

// export const NavTrace = (props: NavTrace) => {
//     const { width, rootCategory, source, thirdPartyImageSource, trace } = props

//     const { id, isOpenToUse, categoryName = "Selected category" } = rootCategory || {}

//     const dispatch = useDispatch();

//     const [rootId, setRootId] = useState(id as any);

//     useEffect(() => {
//         setRootId(id)
//     }, [id])

//     const navTrace = useMemo(() => {
//         return trace.map((crumb, index) => <BreadcrumbItemDirective text={crumb.name} url={`${index}`}>
//             <div onClick={() => {
//                 if (index < trace.length - 1) {
//                     dispatch(removeFromNavTrace(crumb))
//                     dispatch(fetchSubTiles(source as LibrarySourceType, crumb, 0))
//                 }
//             }} className='library_navtrace_crumb'
//                 style={{ backgroundColor: backgroundColors[index + 1], width: 100, height: 40 }}
//                 data-id={crumb.id}>{crumb.name}</div>
//         </BreadcrumbItemDirective>
//         )
//     }, [trace, source])

//     const isRootIdAvailable = rootId && (rootId !== 'evroot') && isOpenToUse

//     const [url, setUrl] = useState(undefined as any)

//     useEffect(() => {
//         alert(url)
//     }, [url])

//     const primaryNavlabel = (source === 'patternDesigns' ? 'All Categories' : 'Search Results')

//     return <BreadcrumbComponent enableNavigation={false} itemTemplate={(data: any) => {
//         return <button onClick={() => { setUrl(data.url) }}>{data.text}</button>
//     }}>
//         <BreadcrumbItemsDirective>
//             <BreadcrumbItemDirective iconCss="e-icons e-home" text={primaryNavlabel} url={primaryNavlabel}/>
//             {navTrace}
//         </BreadcrumbItemsDirective>
//     </BreadcrumbComponent>
// }

// export const Crumb = (data:any)=><div><a href={data.url} className="e-breadcrumb-text">{data.text}</a></div>

export const NavTrace = (props: NavTrace) => {
    const dispatch = useDispatch();

    const { rootCategory, source, thirdPartyImageSource, trace } = props

    const { id, isOpenToUse } = rootCategory || {}

    const [rootId,setRootId] = useState(id as any);

    useEffect(()=>{
        setRootId(id)
    },[id])

    const isSourceResults = !source.endsWith('_searchResults');

    const isRootIdAvailable = rootId && (rootId !== 'evroot') && isOpenToUse
    const primaryNavlabel = ( isSourceResults? 'All Categories' : 'Search Results')

    return <BreadcrumbComponent itemClick={(obj) => {
        const data = obj?.item?.url
        if (data) {
            const crumb = JSON.parse(data);
            if (crumb.name === primaryNavlabel) {
                if (isRootIdAvailable && (isSourceResults)) {
                dispatch(clearRootCategoryId())
                dispatch(clearNavTiles())
                dispatch(setSelectedSource(source))
                dispatch(setUpThirdPartyLibraries({sources:thirdPartyImageSource}))
                } else if (isSourceResults) {
                    dispatch(setSuccess(source))
                    dispatch(clearNavTiles())
                    dispatch(setSelectedSource(source))
                }
            } else {
                if (crumb.index < trace.length - 1) {
                    dispatch(removeFromNavTrace(crumb))
                    dispatch(fetchSubTiles(source as LibrarySourceType, crumb, 0))
                }
            }
        }
    }} enableNavigation={false} key={`${trace && trace.length}`}>
        <BreadcrumbItemsDirective>
            <BreadcrumbItemDirective iconCss="e-icons e-home" url={JSON.stringify({ name: primaryNavlabel })} text={primaryNavlabel} />
            {
                trace.map((crumb, index) => {
                    return <BreadcrumbItemDirective url={JSON.stringify({ ...crumb, index })} text={crumb.name} />
                })
            }
        </BreadcrumbItemsDirective>
    </BreadcrumbComponent>
}
